import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { IMG } from "../lib/assets";

export default function Login() {
  const { user, authLoading } = useStore();
  const navigate = useNavigate();

  useEffect(() => { if (!authLoading && user) navigate("/account", { replace: true }); }, [user, authLoading, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[80vh]" data-testid="login-page">
      <div className="hidden lg:block relative overflow-hidden bg-beige/40">
        <img src={IMG.beige2} alt="SV" className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <div className="flex items-center justify-center px-8 py-20">
        <div className="max-w-sm w-full text-center">
          <p className="overline text-gold mb-4">Members</p>
          <h1 className="h-display text-5xl mb-4">Welcome Back</h1>
          <p className="text-sm text-muted-foreground font-light mb-10">Sign in to track orders, save your favorites, and earn SV Rewards on every purchase.</p>
          <button onClick={signIn} className="btn-primary w-full" data-testid="google-signin-btn">Continue With Google</button>
          <p className="text-[11px] text-muted-foreground font-light mt-6">By continuing you agree to our Terms & Privacy Policy.</p>
        </div>
      </div>
    </div>
  );
}
